import React, { useMemo, useState } from "react";
import Layout from "../../../components/common/Layout";
import { ADMIN_NAV } from "../../../utils/navigation";

import PayrollProcessingToolbar from "../../../components/finance/payroll/payroll-processing/PayrollProcessingToolbar";
import PayrollProcessingSummaryCards from "../../../components/finance/payroll/payroll-processing/PayrollProcessingSummaryCards";
import PayrollProcessingTable from "../../../components/finance/payroll/payroll-processing/PayrollProcessingTable";
import PayrollProcessingModal from "../../../components/finance/payroll/payroll-processing/PayrollProcessingModal";

import {
  payrollProcessing as initialPayroll,
  employeeSalaryAssignments,
} from "../../../data/payrollMockData";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const years = ["2025", "2026", "2027"];

export default function PayrollProcessing() {
  const [payrolls, setPayrolls] = useState(initialPayroll);

  const [search, setSearch] = useState("");
  const [monthFilter, setMonthFilter] = useState("All");
  const [yearFilter, setYearFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPayroll, setSelectedPayroll] = useState(null);

  const filteredPayrolls = useMemo(() => {
    return payrolls.filter((item) => {
      const matchesSearch =
        item.employeeName.toLowerCase().includes(search.toLowerCase()) ||
        item.employeeId.toLowerCase().includes(search.toLowerCase());

      const matchesMonth =
        monthFilter === "All" || item.month === monthFilter;

      const matchesYear =
        yearFilter === "All" || item.year === yearFilter;

      const matchesStatus =
        statusFilter === "All" || item.status === statusFilter;

      return (
        matchesSearch &&
        matchesMonth &&
        matchesYear &&
        matchesStatus
      );
    });
  }, [
    payrolls,
    search,
    monthFilter,
    yearFilter,
    statusFilter,
  ]);

  const handleSave = (data) => {
    if (selectedPayroll) {
      setPayrolls((prev) =>
        prev.map((item) =>
          item.id === selectedPayroll.id
            ? { ...selectedPayroll, ...data }
            : item
        )
      );
    } else {
      setPayrolls((prev) => [
        ...prev,
        {
          id: Date.now(),
          ...data,
        },
      ]);
    }

    setSelectedPayroll(null);
    setIsModalOpen(false);
  };

  const handleDelete = (id) => {
    if (!window.confirm("Delete payroll record?")) return;

    setPayrolls((prev) =>
      prev.filter((item) => item.id !== id)
    );
  };

  return (
    <Layout navItems={ADMIN_NAV}>
      <div className="finance-page">

        <div className="finance-page-header">
          <div>
            <h1>Payroll Processing</h1>
            <p>
              Process monthly payroll and manage employee salary calculations.
            </p>
          </div>
        </div>

        <PayrollProcessingSummaryCards payrolls={payrolls} />

        <PayrollProcessingToolbar
          search={search}
          setSearch={setSearch}
          monthFilter={monthFilter}
          setMonthFilter={setMonthFilter}
          yearFilter={yearFilter}
          setYearFilter={setYearFilter}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
          months={months}
          years={years}
          onAdd={() => {
            setSelectedPayroll(null);
            setIsModalOpen(true);
          }}
        />

        <PayrollProcessingTable
          payrolls={filteredPayrolls}
          onEdit={(record) => {
            setSelectedPayroll(record);
            setIsModalOpen(true);
          }}
          onDelete={handleDelete}
        />

        <PayrollProcessingModal
          isOpen={isModalOpen}
          onClose={() => {
            setSelectedPayroll(null);
            setIsModalOpen(false);
          }}
          onSave={handleSave}
          initialData={selectedPayroll}
          assignments={employeeSalaryAssignments}
        />

        

      </div>
    </Layout>
  );
}                   